export default {"src":"/_next/static/media/gridOutline.ba653cfa.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};